import { Link } from "react-router-dom";
import { MainLogo } from "../assets/main_logo";
import { LoginDialog } from "modules/authentication/components/loginDialog";

interface SimpleHeaderProps {
  className?: string;
}

const SimpleHeader = ({ className }: SimpleHeaderProps) => (
  <header
    className={`flex items-center justify-between px-4 py-3 bg-background border-b ${className ?? ""}`}
  >
    <Link to="/" className="flex items-center gap-2">
      <MainLogo color="#F97316" classname="w-10" />
      <span className="font-bold text-xl mt-3 russo-one-regular logo-text">
        Carriapp
      </span>
    </Link>

    <div className="flex items-center">
      <LoginDialog  size="lg" className="w-32"/>
    </div>
  </header>
);

export default SimpleHeader;
